const EVALUATIONTYPES = {
  Evaluación_Inicial: 1,
  Evaluación_Adicional: 2,
  Reevaluacion: 3,
  Evaluación_Trianual: 4,
  Pruebas_Academicas: 5,
};

export default EVALUATIONTYPES;
